













import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
import { Product, ProductLabel, WebshopBannerType } from '~/types/product'
import { useConfig } from '~/composables/useConfig'
import { useProductDiscounts } from '~/composables/product/useProductDiscounts'

export default defineComponent({
  name: 'ProductTags',

  inheritAttrs: false,

  props: {
    product: {
      type: Object as PropType<Product | null>,
      default: null,
    },
    limit: {
      type: Number,
      default: 5,
    },
    size: {
      type: String,
      default: 'sm',
      validator: (val: string) => {
        return ['xs', 'sm', 'md', 'lg'].includes(val)
      },
    },
    firstTagMode: {
      type: Boolean,
      detault: false,
    },
  },

  setup(props) {
    const noDiscountTags = true
    const { config } = useConfig()
    const discounts = computed(() => props.product?.discounts ?? [])
    const { filteredDiscounts } = useProductDiscounts(discounts)

    const tags = computed(() => {
      const result: ProductLabel[] = []
      let currentOrder = 1

      // webshopBanner
      const webshopBanner = props.product?.webshopBanner
      if (webshopBanner?.type === WebshopBannerType.Tag) {
        result.push({
          name: webshopBanner.name,
          key: 'webshopbanner',
          order: currentOrder++,
        })
      }

      // discounts tags
      if(!noDiscountTags) {
        const discount = props.product?.discount
        const discounts = filteredDiscounts.value
  
        if (discounts?.length) {
          let activeDiscountIndex = -1
          if (discount?.id) {
            activeDiscountIndex = discounts.findIndex(
              (item) => item.id === discount.id
            )
          }
          const discount1 =
            activeDiscountIndex > 0
              ? discounts[activeDiscountIndex]
              : discounts[0]
          const discount2 = activeDiscountIndex > 0 ? discounts[0] : discounts[1]
          result.push(
            {
              key: `discounts-${discount1.id}`,
              name: discount1.name,
              order: currentOrder++,
            },
            ...(discount2
              ? [
                  {
                    key: `discounts-${discount2.id}`,
                    name: discount2.name,
                    order: currentOrder++,
                  },
                ]
              : [])
          )
        }
      }
      

      // to avoid order = 1 for item in tagFields
      if (currentOrder === 1) {
        currentOrder++
      }

      // otherFields tags
      props.product?.tags?.forEach((item) => {
        result.push({
          name: item.name,
          key: item.key,
          order: currentOrder++,
        })
      })

      // console.log('result')
      //   console.log(result)

      return result
    })

    const finalTags = computed(() => {
      if (props.firstTagMode) {
        const firstTag = tags.value.find((tag) => tag.order === 1)
        return firstTag ? [firstTag] : []
      }

      return tags.value.slice(0, props.limit)
    })

    const containsAlcohol = computed(() => {
      return props.product?.containsAlcohol
    })

    const labelsConfig = (item) => {
      return item.key === 'discount' || item.key.includes('discounts-')
        ? config.value?.discountLabelColors
        : config.value?.productLabelColors
    }

    return {
      tags: finalTags,
      labelsConfig,
      containsAlcohol
    }
  },
})
